module.exports = new __parcel__URL__("brickfilm.3c5513fa.webp").toString();